<mat-card *ngIf="apiRestDetailsService?.compteApi">
    <mat-card-title>
        <span [translate]="'admin.parametres.api.rest.details.compte.compteApi'"></span>
    </mat-card-title>
    <mat-card-content>
        <form>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="type"
                                  name="type"
                                  libelle="admin.parametres.api.rest.details.compte.type"
                                  [ngModel]="apiRestDetailsService.compteApi.comptePersonnel ? TypeCompteApi.PERSONNEL : TypeCompteApi.SERVICE"
                                  [selectOptions]="listeTypesPossibles"
                                  customType="select"
                                  optionValue="code"
                                  optionDisplay="libelle"
                                  [required]="true"
                                  [readonly]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="actif"
                                  name="actif"
                                  libelle="admin.parametres.api.rest.details.compte.actif"
                                  postLibelle="admin.parametres.api.rest.details.compte.activerCompte"
                                  [ngModel]="apiRestDetailsService.compteApi.actif"
                                  [(customModel)]="apiRestDetailsService.compteApi.actif"
                                  customType="checkbox">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="identifiant"
                                  name="identifiant"
                                  libelle="admin.parametres.api.rest.details.compte.identifiant"
                                  [(ngModel)]="apiRestDetailsService.compteApi.identifiant"
                                  customType="input"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="dateCloture"
                                  name="dateCloture"
                                  libelle="admin.parametres.api.rest.details.compte.dateCloture"
                                  [ngModel]="apiRestDetailsService.compteApi.dateCloture"
                                  [(customModel)]="apiRestDetailsService.compteApi.dateCloture"
                                  [rCol]="2"
                                  customType="date">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelle"
                                  name="libelle"
                                  libelle="admin.parametres.api.rest.details.compte.libelle"
                                  [(ngModel)]="apiRestDetailsService.compteApi.libelle"
                                  customType="input"
                                  [required]="true">
                    </custom-input>
                    <custom-input *ngIf="!!apiRestDetailsService.compteApi.idCompte"
                                  ngDefaultControl
                                  id="derniereConnexion"
                                  name="derniereConnexion"
                                  libelle="admin.parametres.api.rest.details.compte.derniereConnexion"
                                  [ngModel]="apiRestDetailsService.compteApi.derniereConnexion ? ((apiRestDetailsService.compteApi.derniereConnexion | date:'shortDate') + ' ' + (apiRestDetailsService.compteApi.derniereConnexion | date:'shortTime')) : ('admin.parametres.api.rest.details.compte.aucune' | translate)"
                                  customType="input"
                                  [readonly]="true">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="email"
                                  name="email"
                                  libelle="admin.parametres.api.rest.details.compte.email"
                                  [postTooltip]="'admin.parametres.api.rest.details.compte.emailTooltip' | translate"
                                  [(ngModel)]="apiRestDetailsService.compteApi.email"
                                  customType="input"
                                  [required]="true">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="description"
                                  name="description"
                                  libelle="admin.parametres.api.rest.details.compte.description"
                                  [(ngModel)]="apiRestDetailsService.compteApi.description"
                                  [rCol]="10"
                                  customType="textarea">
                    </custom-input>
                </div>
            </fieldset>
        </form>
    </mat-card-content>
</mat-card>